import { Button, ButtonProps } from '@dfh-corp-sites/ui'
import React from 'react'

import { useAccountsUrl } from '../../lib/accounts/hooks/useAccountsUrl'
import { AccountsPageType } from '../../lib/accounts/types'
import { useSignup } from '../../lib/auth/hooks/useSignup'
import { AccountType } from '../../lib/auth/signup'
import { usePageUrl } from '../../lib/pages'

export interface RegistrationLinkProps {
  accountType?: AccountType | null
  className?: string
  onClick?: (event: React.MouseEvent<HTMLButtonElement>) => void
  variant?: ButtonProps['variant']
  classic?: boolean
  page?: AccountsPageType | null
}

const RegistrationLink: React.FC<RegistrationLinkProps> = ({
  accountType,
  children,
  className,
  onClick,
  variant = 'text',
  classic = false,
  page,
}) => {
  const { navigate } = usePageUrl()
  const { signup } = useSignup()
  const { redirectToAccount } = useAccountsUrl()

  return (
    <Button
      className={className}
      onClick={(event) => {
        onClick?.(event)
        if (classic) {
          return redirectToAccount({
            page: page || 'base',
            registerType: accountType === 'visitor' ? 'patient' : accountType,
          })
        }

        signup({
          page: 'register',
          accountType,
          options: {
            ...(accountType && { 'ext-account-type': accountType }),
          },
        }).catch(() => navigate('/login'))
      }}
      variant={variant}
    >
      {children}
    </Button>
  )
}

export default RegistrationLink
